import axios from "axios";
import config from "config/config";
import { serialize } from "../../core/utils/_util";

axios.defaults.baseURL = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].API_BASE_URL;

export const ALL_RESTAURANT = `/api/v1/restaurants`;
export const CREATE_CUSTOMER_VERIFY = "/api/v1/incentive/send-opt";
export const GENERATE_CODE = "/api/v1/incentive/generate-code";
export const SEND_DRIVER_CODE = "/api/v1/incentive/send-invite";
export const SEND_REFERRAL_LINK = "/api/v1/incentive/send-referral-link";

// getAllRestaurantAPI
export function getAllRestaurantAPI(search) {
  const object = {
    search: search,
  };
  return axios.get(`${ALL_RESTAURANT}?${serialize(object)} `, {
    validateStatus(status) {
      return true;
    },
  });
}

export function createCustomerAndSendOtp(data) {
  return axios.post(`${CREATE_CUSTOMER_VERIFY}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export function generateCodeApi(data) {
  return axios.post(`${GENERATE_CODE}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export function sendDriverCodeAPI(data) {
  return axios.post(`${SEND_DRIVER_CODE}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export function sendReferralLinkAPI(data) {
  return axios.post(`${SEND_REFERRAL_LINK}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export function getIncentiveForRestaurant(restaurantId) {
  return axios.get(`${ALL_RESTAURANT}/${restaurantId}`, {
    validateStatus(status) {
      return true;
    },
  });
}
